import i18n from '@/locales'
export default {
  methods: {
    handleDeleteRow (row) {
      this.createDialog('GuideDeleteStorageDialog', {
        data: [row],
        columns: this.columns,
        title: i18n.t('scope.text_117'),
        manager: this.manager,
        success: this.refresh,
      })
    },
    handleBindHosts (row) {
      this.createDialog('AssociatedHostDialog', {
        data: [row],
        columns: this.columns,
        title: i18n.t('scope.text_118'),
        refresh: this.refresh,
      })
    },
  },
}
